import { createRoute } from '@/utils/routing'

export const BOL_SCREENSHOTS_ROUTE = 'bol-screenshots'

export function createBolScreenshotsRoute (options = {}) {
  return createRoute(BOL_SCREENSHOTS_ROUTE, options)
}
